import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/App';
import '@/app/libs/analytics/init';
import '@/app/libs/clarity/init';
import '@/app/libs/sentry/init';

const root = createRoot(document.getElementById('root') as HTMLElement);

if (import.meta.env.MODE === 'test') {
  import('@/__mocks__/browser')
    .then(({ worker }) => {
      worker.start();
    })
    .then(() => {
      root.render(
        <StrictMode>
          <App />
        </StrictMode>,
      );
    });
} else {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
